export { useModal } from './useModal';
export { ConsentsModal } from './ConsentsModal/ConsentsModal';
export { ConsentsModalHeader } from './ConsentsModal/ConsentsModalHeader';
export { useConsentsModal } from './ConsentsModal/useConsentsModal';
export type {
  Consent,
  DocumentLink,
} from './ConsentsModal/ConsentsModal.types';
